import { useState, useEffect } from 'react';

export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(() => {
    // 初始化时就获取正确的值
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches;
    }
    return false;
  });

  useEffect(() => {
    const media = window.matchMedia(query);
    if (media.matches !== matches) {
      setMatches(media.matches);
    }

    const listener = () => setMatches(media.matches);
    media.addEventListener('change', listener);

    return () => media.removeEventListener('change', listener);
  }, [matches, query]);

  return matches;
}

export function useIsMobile() {
  // Tailwind's `lg` breakpoint starts at 1024px, so mobile must stop at 1023px.
  // Keeping the JS and CSS breakpoints identical prevents a 1024px-wide iPad
  // from receiving mobile component logic inside a desktop layout.
  return useMediaQuery('(max-width: 1023px)');
}

export function useIsTablet() {
  return useMediaQuery('(min-width: 768px) and (max-width: 1024px)');
}

export function useIsDesktop() {
  return useMediaQuery('(min-width: 1025px)');
}

export function useIsIOS() {
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const checkIsIOS = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      const isIOSDevice = /iphone|ipad|ipod/.test(userAgent);
      const isMacSafari = /macintosh/.test(userAgent) && 'ontouchend' in document;
      return isIOSDevice || isMacSafari;
    };

    setIsIOS(checkIsIOS());
  }, []);
  return isIOS;
}
